import moment from 'moment-timezone'
import { APICONFIG } from '../../../redux/config/apiConfig'
moment.tz.setDefault(APICONFIG.timeZone)

export default moment
